import { createEffect } from "effector";
import {
  restCreationMultipartHandler,
  restGetUniqueHandler,
} from "@utils/rest/RestClient";
import { ResourceDetailsResponseDto } from "@state/resource/dto/resource.details.response.dto";
import { ResourceInputList } from "@type/estimateInput/estimateInput.response";

const resourcesUrl = (window as any)?.api_url_resources
  ? (window as any)?.api_url_resources
  : "/ws/resources/";
const farmerResourcesUrl = resourcesUrl + "/FARMER";
const collectivityResourcesUrl = resourcesUrl + "/COLLECTIVITY";

export const requestGetFarmerResources = createEffect({
  handler: restGetUniqueHandler<ResourceInputList>(`${farmerResourcesUrl}`),
});

export const requestGetCollectivityResources = createEffect({
  handler: restGetUniqueHandler<ResourceInputList>(
    `${collectivityResourcesUrl}`
  ),
});

export const requestCreateResource = createEffect({
  handler: restCreationMultipartHandler<ResourceDetailsResponseDto>(
    `${resourcesUrl}`
  ),
});
